import React, {Component} from 'react'
import mapa from '../../img/mapaNew.png'
// import mapa from '../../img/mapa.png'
import strings from '../../strings/localeStrings'
import moment from "moment";
import {Link} from "react-router-dom";
import MediaQuery from 'react-responsive'

export default class AplikacjaMobilna extends Component {

    render() {
        return (
            <div className="mapa">
                <div className="row mobilkaFixRow">
                    <div className="col-xl-2"></div>
                    <div className="col-xl-4">
                        <MediaQuery maxWidth={649}>
                            <center>
                                <div style={{color: '#eaeaea', paddingTop: 50, paddingBottom: 25}}>Aby wyświetlić mapę
                                    wyświetl stronę na ekranie o wyższej rozdzielczości.
                                </div>
                            </center>
                        </MediaQuery>
                        <MediaQuery minWidth={650}>
                            <center>
                                <img src={mapa} useMap="#image-map" className="mapaImage"/>
                                <map name="image-map">
                                    {/*<Link to={'/rozklad/' + moment().format('YYYY-MM-DD') + '/21/Kraków%20-%20Rzeszów'}>*/}
                                    {/*    <area target="" alt="Kraków" title="Kraków" href="" coords="33,323,10"*/}
                                    {/*          shape="circle"/>*/}
                                    {/*</Link>*/}
                                    <Link to={'/rozklad/' + moment().format('YYYY-MM-DD') + '/17/Dębica%20-%20Rzeszów'}>
                                        <area target="" alt="Dębica" title="Dębica" href="" coords="229,335,14"
                                              shape="circle"/>
                                    </Link>
                                    <Link to={'/rozklad/' + moment().format('YYYY-MM-DD') + '/18/Jasło%20-%20Rzeszów'}>
                                        <area target="" alt="Jasło" title="Jasło" href="" coords="247,395,13"
                                              shape="circle"/>
                                    </Link>
                                    <Link to={'/rozklad/' + moment().format('YYYY-MM-DD') + '/22/Krosno%20-%20Rzeszów'}>
                                        <area target="" alt="Krosno" title="Krosno" href="" coords="300,402,11"
                                              shape="circle"/>
                                    </Link>
                                    <Link to={'/rozklad/' + moment().format('YYYY-MM-DD') + '/27/Sanok%20-%20Rzeszów'}>
                                        <area target="" alt="Sanok" title="Sanok" href="" coords="390,428,11"
                                              shape="circle"/>
                                    </Link>
                                    <Link to={'/rozklad/' + moment().format('YYYY-MM-DD') + '/24/Mielec%20-%20Rzeszów'}>
                                        <area target="" alt="Mielec" title="Mielec" href=""
                                              coords="240,274,11" shape="circle"/>
                                    </Link>
                                    <Link
                                        to={'/rozklad/' + moment().format('YYYY-MM-DD') + '/29/Tarnobrzeg%20-%20Rzeszów'}>
                                        <area target="" alt="Tarnobrzeg" title="Tarnobrzeg" href=""
                                              coords="290,222,11" shape="circle"/>
                                    </Link>
                                    <Link
                                        to={'/rozklad/' + moment().format('YYYY-MM-DD') + '/28/Stalowa%20Wola%20-%20Rzeszów'}>
                                        <area target="" alt="Stalowa Wola" title="Stalowa Wola"
                                              href="" coords="330,202,14" shape="circle"/>
                                    </Link>
                                    <Link to={'/rozklad/' + moment().format('YYYY-MM-DD') + '/23/Lublin%20-%20Rzeszów'}>
                                        <area target="" alt="Lublin" title="Lublin" href=""
                                              coords="410,53,13" shape="circle"/>
                                    </Link>
                                    <Link to={'/rozklad/' + moment().format('YYYY-MM-DD') + '/105/Rymanów%20Zdrój%20-%20Lublin'}>
                                        <area target="" alt="Rymanow Zdroj" title="Rymanów Zdrój" href="" coords="315,460,11"
                                              shape="circle"/>
                                    </Link>
                                    <Link to={'/rozklad/' + moment().format('YYYY-MM-DD') + '/107/Polańczyk%20-%20Rzeszów'}>
                                        <area target="" alt="Polanczyk" title="Polańczyk" href="" coords="455,490,11"
                                              shape="circle"/>
                                    </Link>
                                </map>
                            </center>
                        </MediaQuery>
                    </div>
                    <div className="col-xl-4 paddingLeftRight50" style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignContent: 'center',
                        flexDirection: 'column'
                    }}>
                        <h2 style={{fontWeight: 'bold'}}>{strings.mapaPolaczen}</h2>
                        <p>{strings.mapaPolaczenTresc}</p>
                        <p>
                            <ul>
                                <li>Lublin - Rzeszów - Rymanów Zdrój</li>
                                <li>Lublin - Rzeszów</li>
                                <li>Jasło - Strzyżów - Rzeszów</li>
                                <li>Krosno - Lutcza - Rzeszów</li>
                                <li>Stalowa Wola - Kamień - Rzeszów</li>
                                <li>Tarnobrzeg - Kolbuszowa - Rzeszów</li>
                                <li>Mielec - Kolbuszowa - Rzeszów</li>
                                {/*<li>Dębica - Ropczyce - Rzeszów</li>*/}
                                <li>Sanok - Brzozów - Rzeszów</li>
                                <li>Polańczyk - Sanok - Rzeszów</li>
                            </ul>
                        </p>
                    </div>

                </div>
            </div>
        )
    }

}



// WEBPACK FOOTER //
// ./src/components/home/homeComponents/Mapa.js